import FeaturedServices from './FeaturedServices';

export { TYPE } from './constants';
export default FeaturedServices;
